import _ from 'underscore';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import { withControlErrorHandling } from '@bingads-webui-campaign-react/error-handling';
import { ValidatedCollapseCard, FormCardBasicHeader } from '@bingads-webui-campaign-react/validated-form-cards';
import { FormCardBody } from '@bingads-webui-fluent-component/form-cards';
import { ArrowSwap24Regular } from '@fluentui/react-icons';

import { ConversionSkeleton } from '../components/skeletons';
import { ConversionGoals } from '../components/conversion-goals';
import { NoCompatibleGoalsWarningMessage } from '../components/warning-message';
import { withValidationWrapper } from '../utils';

const ServerValidatedConversionGoals = _.compose(
  withControlErrorHandling,
  withValidationWrapper
)(ConversionGoals);

export const CollapsibleConversionGoals = ({
  isEditMode,
  isLoading,
  hasLinkedInCompatibleGoals,
  onNavigateToConversionGoalsClicked,
  ...cardProps
}) => {
  const i18n = useContext(I18nContext);

  return (
    <ValidatedCollapseCard {...cardProps}>
      <FormCardBasicHeader
        title={i18n.getString(_TL_('Conversions'))}
        contentBefore={<ArrowSwap24Regular />}
        helpLabel={i18n.getString(_TL_('Click to learn more about conversions'))}
        helpTopic="pop_BA_LinkedIn_Conversions"
      />
      <FormCardBody>
        {!isLoading && hasLinkedInCompatibleGoals && (
          <ServerValidatedConversionGoals
            validationProps={{ field: 'conversionGoals' }}
          />
        )}
        {!isLoading && !hasLinkedInCompatibleGoals && (
          <NoCompatibleGoalsWarningMessage
            isEditMode={isEditMode}
            onNavigateToConversionGoalsClicked={onNavigateToConversionGoalsClicked}
          />
        )}
        {isLoading && <ConversionSkeleton />}
      </FormCardBody>
    </ValidatedCollapseCard>
  );
};

CollapsibleConversionGoals.propTypes = {
  isEditMode: PropTypes.bool,
  isLoading: PropTypes.bool.isRequired,
  hasLinkedInCompatibleGoals: PropTypes.bool.isRequired,
  onNavigateToConversionGoalsClicked: PropTypes.func.isRequired,
};

CollapsibleConversionGoals.defaultProps = {
  isEditMode: false,
};
